import { render, staticRenderFns } from "./CatalogFilterContainer.vue?vue&type=template&id=178934d9&scoped=true&"
import script from "./CatalogFilterContainer.vue?vue&type=script&lang=js&"
export * from "./CatalogFilterContainer.vue?vue&type=script&lang=js&"
import style0 from "./CatalogFilterContainer.vue?vue&type=style&index=0&id=178934d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178934d9",
  null
  
)

export default component.exports